(() => {

    /* ==========================================
       MOVE BADGES PARA DENTRO DA GALERIA
    ========================================== */

    const moveBadges = () => {

        const badges =
            document.querySelector(
                '.product-page-badges'
            );

        const media =
            document.querySelector(
                'media-gallery .product-media'
            ) ||
            document.querySelector(
                'media-gallery .product__media'
            ) ||
            document.querySelector(
                'media-gallery .product-gallery'
            );

        /* ELEMENTOS NÃO ENCONTRADOS */
        if (!badges || !media)
            return;

        /* JÁ FOI MOVIDO */
        if (badges.parentElement === media)
            return;

        /* GARANTE REFERÊNCIA ABSOLUTA */
        media.style.position =
            'relative';

        /* MOVE OS BADGES */
        media.append(
            badges
        );

    };

    /* ==========================================
       EXECUÇÃO INICIAL
    ========================================== */

    moveBadges();

    requestAnimationFrame(
        moveBadges
    );

    window.addEventListener(
        'load',
        moveBadges
    );

    /* ==========================================
       OBSERVA ALTERAÇÕES DO DOM
    ========================================== */

    const observer =
        new MutationObserver(
            mutations => {

                for (const mutation of mutations) {

                    if (
                        mutation.addedNodes.length
                    ) {

                        moveBadges();
                        break;

                    }

                }

            }
        );

    observer.observe(
        document.body,
        {
            childList: true,
            subtree: true
        }
    );

})();